import type { WebSocketMessageType } from '../interfaces/websocket.interface';

type EventCallback = (data: any) => void;

export class EventBus {
  private listeners = new Map<string, Set<EventCallback>>();

  on(type: WebSocketMessageType | string, callback: EventCallback): () => void {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, new Set());
    }
    this.listeners.get(type)?.add(callback);

    return () => {
      this.listeners.get(type)?.delete(callback);
      if (this.listeners.get(type)?.size === 0) {
        this.listeners.delete(type);
      }
    };
  }

  emit(type: string, data?: any): void {
    const callbacks = this.listeners.get(type);
    if (!callbacks) return;

    // Snapshot before iterating — safe if a listener unsubscribes
    // itself or others during delivery
    const snapshot = Array.from(callbacks);
    for (const callback of snapshot) {
      try {
        callback(data);
      } catch (err) {
        console.error(`EventBus listener error for ${type}:`, err);
      }
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
